const countryData = [
  {
    name: "United States",
    code: "+1",
    flag: "https://flagcdn.com/w20/us.png"
  },
  {
    name: "Afghanistan",
    code: "+93",
    flag: "https://flagcdn.com/w20/af.png"
  },
  {
    name: "Åland Islands",
    code: "+358",
    flag: "https://flagcdn.com/w20/ax.png"
  },
  {
    name: "Albania",
    code: "+355",
    flag: "https://flagcdn.com/w20/al.png"
  },
  {
    name: "Algeria",
    code: "+213",
    flag: "https://flagcdn.com/w20/dz.png"
  },
  {
    name: "Andorra",
    code: "+376",
    flag: "https://flagcdn.com/w20/ad.png"
  },
  {
    name: "Angola",
    code: "+244",
    flag: "https://flagcdn.com/w20/ao.png"
  },
  {
    name: "Anguilla",
    code: "+1264",
    flag: "https://flagcdn.com/w20/ai.png"
  },
  {
    name: "Antigua & Barbuda",
    code: "+1268",
    flag: "https://flagcdn.com/w20/ag.png"
  },
  {
    name: "Argentina",
    code: "+54",
    flag: "https://flagcdn.com/w20/ar.png"
  },
  {
    name: "Armenia",
    code: "+374",
    flag: "https://flagcdn.com/w20/am.png"
  },
  {
    name: "Aruba",
    code: "+297",
    flag: "https://flagcdn.com/w20/aw.png"
  },
  {
    name: "Australia",
    code: "+61",
    flag: "https://flagcdn.com/w20/au.png"
  },
  {
    name: "Austria",
    code: "+43",
    flag: "https://flagcdn.com/w20/at.png"
  },
  {
    name: "Azerbaijan",
    code: "+994",
    flag: "https://flagcdn.com/w20/az.png"
  },
  {
    name: "Bahamas",
    code: "+1242",
    flag: "https://flagcdn.com/w20/bs.png"
  },
  {
    name: "Bahrain",
    code: "+973",
    flag: "https://flagcdn.com/w20/bh.png"
  },
  {
    name: "Bangladesh",
    code: "+880",
    flag: "https://flagcdn.com/w20/bd.png"
  },
  {
    name: "Barbados",
    code: "+1246",
    flag: "https://flagcdn.com/w20/bb.png"
  },
  {
    name: "Belarus",
    code: "+375",
    flag: "https://flagcdn.com/w20/by.png"
  },
  {
    name: "Belgium",
    code: "+32",
    flag: "https://flagcdn.com/w20/be.png"
  },
  {
    name: "Belize",
    code: "+501",
    flag: "https://flagcdn.com/w20/bz.png"
  },
  {
    name: "Benin",
    code: "+229",
    flag: "https://flagcdn.com/w20/bj.png"
  },
  {
    name: "India",
    code: "+91",
    flag: "https://flagcdn.com/w20/in.png"
  }
];

export default countryData;